import { render, staticRenderFns } from "./qywxAccountActivation.vue?vue&type=template&id=c95d1d92&scoped=true"
import script from "./qywxAccountActivation.vue?vue&type=script&lang=js"
export * from "./qywxAccountActivation.vue?vue&type=script&lang=js"
import style0 from "./qywxAccountActivation.vue?vue&type=style&index=0&id=c95d1d92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95d1d92",
  null
  
)

export default component.exports